export const AuditActions = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
  PERFORM: 'perform',
};

export const AuditLogsRouteNames = {
  AUDIT_LOGS: 'auditlogs',
};

export const AuditLogsEntityTypes = {
  USERS: 'users',
  CLUSTERS: 'clusters',
  CLIENTS: 'clients',
  CLIENTGROUPS: 'clientgroups',
  ROLES: 'roles',
  CUSTOMTRANSLATIONS: 'customtranslations',
  DASH: 'dash',
  GRANULARPERMISSIONS: 'granularpermissions',
  CALCULATIONS: 'calculations',
  EXECUTIVESUMMARIES: 'executive_summary_items',
  SCHEDULEDREPORTS: 'scheduledreports',
  MARGINRULES: 'marginrules',
  IMPORTWIZARD: 'importwizard',
  DASHFOLDERS: 'dashfolders',
  CATEGORIES: 'categories',
  GOALS: 'goals',
  SERVICELOOKUPS: 'servicelookups',
  DATAEXPORTERS: 'dataexporters',
  ALERTS: 'alerts',
  DATALOADNOTIFICATIONS: 'notificationrules',
  DASHBOARDTEMPLATES: 'dashboardtemplates',
  SECTIONSTEMPLATES: 'sectionstemplates',
  WIDGETSTEMPLATES: 'widgetstemplates',
  GLOBALFILTERS: 'globalfilters',
  SERVICECLIENTMAPPINGS: 'serviceclientmappings',
  SMARTSLIDES: 'smartslidesslide',
  SMARTSLIDESTEMPLATE: 'smartslidestemplate',
  REPORTINGTEMPLATES: 'reportingtemplates',
  REPORTINGPROFILES: 'reportingprofiles',
  QUEUES: 'queue',
  CONTENTSETS: 'contentsets',
  ENTITYFIELDS: 'entityfields',
  ENTITYGROUPS: 'entitygroups',
  ENTITYSTEPS: 'entitysteps',
  ENTITYFORMS: 'entityforms',
  ORDERS: 'entity/orders',
  LINE_ITEMS: 'entity/lineitems',
  FLIGHTS: 'entity/flights',
  TASKS: 'entity/tasks',
  WORKFLOWS: 'workflow',
};

export const AuditLogsCategories = {
  ORDER_FIELDS: 'order_fields',
  LINE_ITEM_FIELDS: 'line_item_fields',
  FLIGHT_FIELDS: 'flight_fields',
  ORDER_STATUS: 'order_status',
  LINE_ITEM_STATUS: 'line_item_status',
  FLIGHT_STATUS: 'flight_status',
  TASKS: 'tasks',
  SMART_SLIDES: 'smart_slides',
  WORKFLOW: 'workflow',
};

// Field change source types (how a field value was changed)
export const ChangeSourceTypes = {
  DIRECT: 'direct',
  CASCADE: 'cascade',
  ROLLUP: 'rollup',
  DISTRIBUTION: 'distribution',
  CALCULATION: 'calculation',
  UNKNOWN: 'unknown',
};
